import type { CartRepository } from '../../domain/repositories/CartRepository';

export class UpdateCartItemUseCase {
  constructor(private repository: CartRepository) {}

  async execute(itemId: string, quantity: number) {
    return await this.repository.updateQuantity(itemId, quantity);
  }
}
